var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 84,
    viewBox: "0 0 83 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_10739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7315 58.2735C51.8636 54.4056 46.6176 52.2326 41.1475 52.2326C35.6774 52.2326 31.1384 53.6985 27.2705 57.5664",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.7646,
    cy: 45.8057,
    r: 3.6123,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.2354,
    cy: 45.8057,
    r: 3.6123,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1365 18.0682L71.1367 18.0684C71.7719 18.7036 72.125 19.5651 72.125 20.4545V20.9434H52.375V1.19336H52.8639C53.7706 1.19336 54.6317 1.54724 55.2662 2.18168L71.1365 18.0682ZM46.1875 1.19336V22.7402C46.1875 25.1562 48.1621 27.1309 50.5781 27.1309H72.125V79.8027C72.125 81.6826 70.6143 83.1934 68.7344 83.1934H14.2656C12.3857 83.1934 10.875 81.6826 10.875 79.8027V4.58398C10.875 2.70407 12.3857 1.19336 14.2656 1.19336H46.1875Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_10739"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83,
    height: 83,
    fill: "white",
    transform: "translate(0 0.693359)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileicon);
export default __webpack_public_path__ + "static/media/fileicon.fdd8fbd222fa0ecda2e5b5251b7a9c10.svg";
export { ForwardRef as ReactComponent };